/**
 * ハンバーガーメニュー
 * @param {string} eventClass - ハンバーガーボタンのクラス名
 */
export function hamburger(eventClass) {
  const eventElm = document.getElementsByClassName(eventClass)[0];
  if (!eventElm) return;

  const targetClass = eventElm.dataset.target;
  const target = document.getElementsByClassName(targetClass)[0];
  const body = document.getElementsByTagName('body')[0];
  const closeElm = document.getElementsByClassName('js-hamburger-close')[0];
  let offsetY = 0;

  const removeTransition = function (target) {
    setTimeout(function () {
      target.style.transition = '';
    }, 1000);
  };

  const toggleMenu = function () {
    eventElm.classList.toggle('is-active');
    target.style.transition = 'all .3s ease-in-out';
    target.classList.toggle('is-show');
    body.classList.toggle('is-nav-open');

    if (eventElm.classList.contains('is-active')) {
      offsetY = window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.top = -1 * offsetY + 'px';
    } else {
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, offsetY);
      removeTransition(target);
    }
  };

  // 要素外クリックで閉じる
  document.addEventListener('click', function (e) {
    if (
      !e.target.closest('.' + targetClass) &&
      eventElm.classList.contains('is-active') &&
      !e.target.closest('.' + eventClass)
    ) {
      toggleMenu();
    }
  });

  // ハンバーガーボタンクリック
  eventElm.addEventListener('click', function (e) {
    if (!e.isTrusted) return false;
    toggleMenu();
  });

  // ホバーで開く
  eventElm.addEventListener('mouseenter', function () {
    if (!eventElm.classList.contains('is-active')) {
      eventElm.dispatchEvent(new Event('click'));
    }
  });

  // 閉じるボタン
  if (closeElm) {
    closeElm.addEventListener('click', toggleMenu);
  }
}
